import { render, staticRenderFns } from "./TurnSummary.vue?vue&type=template&id=ff982820&scoped=true&"
import script from "./TurnSummary.vue?vue&type=script&lang=js&"
export * from "./TurnSummary.vue?vue&type=script&lang=js&"
import style0 from "./TurnSummary.vue?vue&type=style&index=0&id=ff982820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff982820",
  null
  
)

export default component.exports